export const projects = [
  {
    id: 1,
    title: "podCaster - A GenAI powered Podcast Generator",
    description:
      "PodCaster AI is a Django-powered web app that lets you generate podcast scripts using AI and convert them into natural-sounding audio with Piper TTS — all offline and fully customizable.",
    tech: ["Python", "Django", "AI", "Piper TTS", "Gemini"],
    github: "https://github.com/blackwolf2902/podCaster",
    image: "/images/pod_logo.png",
    demo: "#",
    featured: false,
    patent: false,
    category: "Full Stack",
  },
  {
    id: 2,
    title: "MedBot - AI Medicinal Plant Detection",
    description:
      "Autonomous robot using NVIDIA Jetson Nano to identify medicinal plants in remote areas with real-time image classification and deep learning techniques.",
    tech: ["Python", "TensorFlow", "Jetson SDK", "OpenCV", "Computer Vision"],
    github: "#",
    demo: "#",
    image: "/images/pm-bot.png",
    featured: true,
    patent: true,
    category: "AI/ML",
  },
  {
    id: 3,
    title: "Voice Cloning AI System",
    description:
      "Advanced voice cloning interface using TortoiseTTS library with machine learning techniques to transform and clone voices with high fidelity.",
    tech: ["Python", "TortoiseTTS", "JupyterLab", "Audio Processing"],
    github: "https://github.com/blackwolf2902/Voice-Cloning-AI",
    demo: "#",
    image: "/images/voice-ai.jpg",
    featured: false,
    patent: false,
    category: "AI/ML",
  },
  {
    id: 4,
    title: "Org-Assist Chatbot",
    description:
      "Intelligent organizational assistant web application with NLP capabilities for information queries and complaint management through conversational AI.",
    tech: ["Python", "MongoDB", "NLP", "Flask"],
    github: "https://github.com/blackwolf2902/Org-Assist",
    demo: "#",
    image: "/images/orgAssist.png",
    featured: true,
    patent: false,
    category: "NLP",
  },
  {
    id: 5,
    title: "Heritage Monument Detection",
    description:
      "Machine Learning web application using Streamlit and YOLOv8 for detecting heritage monuments from satellite images with high accuracy.",
    tech: ["Python", "YOLOv8", "Streamlit", "Computer Vision", "Satellite Imagery"],
    github: "https://github.com/blackwolf2902/Heritage-Monument-Detection",
    demo: "#",
    image: "/images/hm-bot.png",
    featured: false,
    patent: false,
    category: "Computer Vision",
  },
];
